import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cscontinue(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Continue tutorial For Beginners</title>
 <meta name="description" content="C# Continue tutorial for beginners.When a c# Continue is encountered inside any loop, control automatically passes to the first statement after the loop,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Continue,c# Continue for,c sharp Continue,c# Continue for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,Continue foreach c#,c# foreach Continue,c# foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-continue" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Continue</h1>
    <div className="first">
        <a href="/csharp-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-goto">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

<p className="mt-4 para">A CSharp continue is usually associated with an if
</p>



<h2 className='headings'>Syntax for continue in C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5"> Continue</span>
            <span className="qwerty-3">;</span>  
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">How to use Continue in C#:</h2>



<h2 className='headings'>Q-Write a program loop start from 1 to 10 and continue on 4 example in c#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-7">Continue</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">if </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-1"> == </span>
            <span className="qwerty-10">4</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">continue</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">1</span>
              {"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}
              </code></pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program loop start from 1 to 10 and continue on 4 and print string before continue example in c#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-7">Continue</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">if </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-1"> == </span>
            <span className="qwerty-10">4</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-5">this </span>
              <span className="qwerty-10">is </span>
              <span className="qwerty-6">continue </span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">continue</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">1</span>
              {"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-5">this </span>
              <span className="qwerty-10">is </span>
              <span className="qwerty-6">continue </span>
              {"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}
              </code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program loop start from 1 to 10 and continue on 4 and 8 and Print String example in c#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-7">Continue</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">if </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-1"> == </span>
            <span className="qwerty-10">4</span>
            <span className="qwerty-3">||</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-1"> == </span>
            <span className="qwerty-10">8</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-5">this </span>
              <span className="qwerty-10">is </span>
              <span className="qwerty-6">continue </span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">continue</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">1</span>
              {"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-5">this </span>
              <span className="qwerty-10">is </span>
              <span className="qwerty-6">continue </span>
              {"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-5">this </span>
              <span className="qwerty-10">is </span>
              <span className="qwerty-6">continue </span>
              {"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}
              </code></pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/csharp-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-goto">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cscontinue;